import React from 'react';

import styled from 'styled-components';

import classLogo from '../images/class-logo-reversed.svg';

const StyledImage = styled.img`
    max-width: 24px;
    max-height: 24px;
    margin-right: 4px;
`;

const ClassLogoForHeader = () => <StyledImage src={classLogo} alt="class logo" />;

export default ClassLogoForHeader;
